/* tslint:disable */
/* tslint:disable */
import {Inject, Injectable, Optional} from '@angular/core';
import {Http} from '@angular/http';
import {SDKModels} from './SDKModels';
import {BaseLoopBackApi} from '../core/base.service';
import {LoopBackConfig} from '../../lb.config';
import {LoopBackAuth} from '../core/auth.service';
import {JSONSearchParams} from '../core/search.params';
import {ErrorHandler} from '../core/error.service';
import {Observable} from 'rxjs/Rx';
import {SFEmployeePayrollData} from '../../models/SFEmployeePayrollData';
import {SocketConnection} from '../../sockets/socket.connections';


/**
 * Api services for the `SFEmployeePayrollData` model.
 */
@Injectable()
export class SFEmployeePayrollDataApi extends BaseLoopBackApi {

  constructor(
    @Inject(Http) protected http: Http,
    @Inject(SocketConnection) protected connection: SocketConnection,
    @Inject(SDKModels) protected models: SDKModels,
    @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    @Inject(JSONSearchParams) protected searchParams: JSONSearchParams,
    @Optional() @Inject(ErrorHandler) protected errorHandler: ErrorHandler
  ) {
    super(http,  connection,  models, auth, searchParams, errorHandler);
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} cont
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFEmployeePayrollData` object.)
   * </em>
   */
  public getCountEmployee(customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/SFEmployeePayrollData/getCountEmployee";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {Number} limit
   *
   * @param {Number} start
   *
   * @param {String} searchtext
   *
   * @param {object} cont
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFEmployeePayrollData` object.)
   * </em>
   */
  public getListEmployee(limit: any = {}, start: any = {}, searchtext: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/SFEmployeePayrollData/getListEmployee";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof limit !== 'undefined' && limit !== null) _urlParams.limit = limit;
    if (typeof start !== 'undefined' && start !== null) _urlParams.start = start;
    if (typeof searchtext !== 'undefined' && searchtext !== null) _urlParams.searchtext = searchtext;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {String} empId
   *
   * @param {object} cont
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFEmployeePayrollData` object.)
   * </em>
   */
  public getempdetail(empId: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/SFEmployeePayrollData/getempdetail";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof empId !== 'undefined' && empId !== null) _urlParams.empId = empId;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} data Request data.
   *
   *  - `empId` – `{String}` -
   *
   *  - `params` – `{Object}` -
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFEmployeePayrollData` object.)
   * </em>
   */
  public updatemppaydata(empId: any = {}, params: any, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/SFEmployeePayrollData/updatemppaydata";
    let _routeParams: any = {};
    let _postBody: any = {
      params: params
    };
    let _urlParams: any = {};
    if (typeof empId !== 'undefined' && empId !== null) _urlParams.empId = empId;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} data Request data.
   *
   *  - `value` – `{String}` - 
   *
   *  - `empId` – `{String}` - 
   *
   *  - `typeValue` – `{String}` - 
   *
   *  - `formulaStatus` – `{String}` - 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFEmployeePayrollData` object.)
   * </em>
   */
  public updatemppaydatabycomp(value: any = {}, empId: any = {}, typeValue: any = {}, formulaStatus: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/SFEmployeePayrollData/updatemppaydatabycomp";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof value !== 'undefined' && value !== null) _urlParams.value = value;
    if (typeof empId !== 'undefined' && empId !== null) _urlParams.empId = empId;
    if (typeof typeValue !== 'undefined' && typeValue !== null) _urlParams.typeValue = typeValue;
    if (typeof formulaStatus !== 'undefined' && formulaStatus !== null) _urlParams.formulaStatus = formulaStatus;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} cont
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFEmployeePayrollData` object.)
   * </em>
   */
  public bankName(customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/SFEmployeePayrollData/bankName";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
   * (The remote method definition does not provide any description.)
   * </em>
   *
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SFEmployeePayrollData` object.)
   * </em>
   * @param customHeaders
   */
  public getListPeriodCode(customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/SFEmployeePayrollData/getListPeriodCode";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    return this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `SFEmployeePayrollData`.
   */
  public getModelName() {
    return "SFEmployeePayrollData";
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/services/custom/SFEmployeePayrollData.ts